import React from 'react';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { createHashHistory } from 'history';
import { Routes } from './routes';
import { ReduxProvider } from '@sde/widgets-core/src/redux/ReduxProvider';
import { store } from './globals';
import { Path, To } from 'history';

const patchHashHistory = (history: any) => {
  return {
    ...history,
    createURL: (location: To) => {
      const base = document.baseURI || window.location.origin;
      return `${base}#${history.createHref(location)}`;
    },
    encodeLocation: (location: Path) => ({
      ...location,
      pathname: encodeURI(location.pathname),
      search: encodeURI(location.search),
      hash: encodeURI(location.hash),
    }),
  };
};

export const browser = () => {
  const patchedHistory = patchHashHistory(createHashHistory());

  return (
    <ReduxProvider store={store}>
      <HistoryRouter history={patchedHistory}>
        <Routes />
      </HistoryRouter>
    </ReduxProvider>
  );
};
